<template>
  <div class="flex-col">
    <!-- <div class="flex-row justify-between self-center section_3">
      <el-breadcrumb separator-class="el-icon-minus">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span class="text-sm">首页</span></el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/supplyList' }">
            <span class="text-sm">供应链</span></el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="text-sm">详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->

    <div class="flex align-center justify-between padding-sm bg-white margin-tb section_3">
      <el-breadcrumb separator-class="el-icon-minus">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span class="text-sm">首页</span></el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/supplyList' }">
          <span class="text-sm">供应链</span></el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="text-sm">详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-col self-end group_5">
      <div class="flex-row items-start self-start group_6 space-x-25">
        <div class="flex-row flex-auto section_4 space-x-29">

          <el-carousel loop indicator-position="outside" height="395px" class="flex-auto image_7">
            <el-carousel-item v-for="item in goodsInfo.images" :key="item">
              <img :src="item" class="flex-auto image_7">
            </el-carousel-item>
          </el-carousel>


          <div class="flex-col items-start shrink-0 group_9">
            <div>
              <span class="font_5 twoHide">
                {{goodsInfo.name}}
              </span>
            </div>
            <div class="listBox">
              <!-- 子项 -->
              <div class="listRow">
                <div class="title">供应商：</div>
                <div class="titleValue oneHide" style="width: 210px;text-align: left;">{{goodsInfo.company.name}}</div>
              </div>

              <div class="listRow">
                <div class="title">商品规格：</div>
                <div class="titleValue">{{goodsInfo.spec}}</div>
              </div>

              <div class="listRow">
                <div class="title">最少起订量：</div>
                <div class="titleValue">{{goodsInfo.start_name}}</div>
                <!-- {{goodsInfo.spec}} -->
              </div>

              <div class="listRow">
                <div class="title">预计出货日：</div>
                <div class="titleValue">{{goodsInfo.day}}天</div>
              </div>

            </div>

            <div class="flex-row items-center space-x-31">
              <span class="font_7">
                购买数量：
                <br />
              </span>
              <div class="flex-row">
                <div class="flex-col justify-start items-center text-wrapper_4" @click="maxFun">
                  <span class="font_10 text_23">+</span>
                </div>
                <div class="flex-col justify-start items-center text-wrapper_5">
                  <span class="font_11 text_24">{{shopNum}}</span>
                </div>
                <div class="flex-col justify-start items-center text-wrapper_6" @click="minFun">
                  <span class="font_3 text_25">-</span>
                </div>
              </div>
            </div>
            <div class="flex-row items-center section_7 space-x-10" @click="dialogVisible = true">
              <img class="shrink-0 image_10"
                src="../../assets/img/money.png" />
              <span class="font_3 text_26">联系厂家购买</span>
            </div>
          </div>
        </div>
        <div class="flex-col shrink-0 group_7">
          <div class="flex-row items-center group_8 space-x-9">
            <div class="section_5"></div>
            <span class="text_13">最新供应</span>
          </div>
          <!-- 侧边栏子项 -->
          <div class="flex-row section_6" v-for="item in goodsSite" @click="toDetail(item.id)">
            <img class="self-center image_8" :src="item.logo" />
            <div class="flex-col self-start group_10 view">
              <div class="flex-col items-start">
                <span class="font_6 text_14 oneHide">{{item.name}}</span>
                <span class="font_1 text_15">起批：{{item.start_name}}{{item.spec}}</span>
                <span class="font_8 text_16">价格{{item.price}}元</span>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="flex-row justify-between">
        <div class="flex-col section_8">
          <div class="flex-col">
            <div class="flex-col justify-start relative group_16">
              <div class="flex-row section_9 space-x-49">
                <span :class="tabIndex==index?'font_10 tabActive':'font_10'" v-for="(item,index) in tab"
                  @click="tabFun(index)">{{item}}</span>
              </div>
            </div>


            <div class="tabContent">


              <div v-show="tabIndex==0">
                <div v-html="goodsInfo.company.content"></div>
                <img :src="goodsInfo.company.img" class="firmLogo" v-if="goodsInfo.company.img">
              </div>

              <div v-show="tabIndex==1">
                <div v-html="goodsInfo.des"></div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <el-dialog title="厂家信息" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="userInfo">负责人姓名：{{goodsInfo.company.user_name}}</div>
      <div class="userInfo">联系方式：{{goodsInfo.company.user_phone}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Bus from '@/store/eventBus.js';
  export default {
    components: {},
    data() {
      return {
        dialogVisible: false, //是否弹出提示框
        shopNum: 1, //当前选择购买数量
        goodsInfo: {},
        goodsSite: [], //侧边栏
        tab: //选项类
          [
            '产品介绍',
            '企业介绍'
          ],
        tabIndex: 0, //当前选中的选项
        tabContent: '' //当前选中后的内容
      };
    },
    created() {
      //给组件传值，选中的页面
      Bus.$emit('chosename', 'supplyList')
    },
    mounted() {
      // 获取商品详情
      this.getGoods(this.$route.query.id);
      // 获取最新产品
      this.getNewGoods();
    },
    methods: {
      // 跳转最新产品详情
      toDetail(id){
        this.$router.push({
          name:'supplyDetail',
            query:{
            id
          }
        },()=>{
          this.$router.go(0)
        })
      },
      // 获取最新产品
      getNewGoods(){
        this.ajax('get', '/api/pc/goods/getGoodsList', {
          page:0
        }, res => {
        	this.goodsSite = res.data;
        });
      },
      // 加
      maxFun() {
        this.shopNum++
      },
      // 减
      minFun() {
        if (this.shopNum <= this.goodsInfo.start_name) {
          return false;
        }
        this.shopNum--
      },
      // 请求商品数据
      getGoods(id) {
        this.ajax('get', '/api/pc/goods/getGoodsInfo', {
          id
        }, res => {
          this.goodsInfo = res.data;
          this.shopNum = res.data.start_name;
        });
      },
      // 退回上一步
      backFun() {
        this.$router.back()
      },
      tabFun(index) {
        this.tabIndex = index;
        if (index == 0) {
          this.tabContent = this.goodsInfo.goodsDes;
        } else {
          this.tabContent = this.goodsInfo.firmDes;
        }
      },
      // 弹出商家信息
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }

    },
  };
</script>

<style scoped lang="css">
  /deep/ .el-dialog__body{
    padding-bottom: 10px;
  }

  .userInfo{
    font-size: 16px;
    margin-bottom: 20px;
  }

  .tabContent {
    padding: 20px 34px 0px 31px;
    text-align: left;
  }

  .firmLogo {
    width: 100%;
    height: 410px;
    margin-top: 30px;
  }

  .tabActive {
    color: #0B837C !important;
    position: relative;
  }

  .tabActive::after {
    content: '';
    width: 27px;
    height: 6px;
    background: #0B837C;
    border-radius: 3px;
    position: absolute;
    bottom: -26px;
    left: 23px;
  }

  .listBox {
    margin-top: 40px;
  }

  .listRow {
    display: flex;
  }

  .title {
    width: 90px;
    font-size: 14px;
    font-weight: 400;
    color: #BEBEBE;
    line-height: 1.5;
    text-align: left;
    margin-bottom: 10px;
  }

  .titleValue {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 1.5;
    margin-left: 0.15rem;
  }

  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .backIcon {
    font-size: 17px;
    color: #999;
    font-weight: bold;
  }

  .font_1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 13px;
    color: #666666;
  }

  .group {
    padding: 16px 0 11px;
    width: 1212px;
  }

  .image_3 {
    width: 62px;
    height: 62px;
  }

  .group_3 {
    margin-left: 29px;
  }

  .space-x-4>*:not(:first-child) {
    margin-left: 4px;
  }

  .image_4 {
    width: 17px;
    height: 20px;
  }

  .font_2 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 32px;
    color: #333333;
  }

  .text_2 {
    line-height: 15px;
  }

  .image_5 {
    margin-left: 18px;
    width: 11px;
    height: 6px;
  }

  .group_2 {
    padding: 13px 0 19px;
    width: 379px;
  }

  .text-wrapper {
    margin-right: 11px;
    padding: 16px 0;
    background-color: #ffffff;
    box-shadow: -3.5px 3.5px 19px 1px #cccccc33;
    border-radius: 21.5px;
    width: 368px;
  }

  .text_3 {
    margin-left: 21px;
    color: #a1a1a1;
    font-size: 13px;
    line-height: 12px;
  }

  .image_2 {
    width: 76px;
    height: 75px;
  }

  .pos {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .section_2 {
    background-color: #09827b;
    box-shadow: 0px 10px 27px 3px #dfdcdc4d;
  }

  .font_3 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 17px;
    color: #ffffff;
  }

  .text_4 {
    margin-left: 401px;
  }

  .text_5 {
    margin-left: 54px;
  }

  .text_6 {
    margin-left: 54px;
  }

  .text_7 {
    margin-left: 55px;
  }

  .text_8 {
    margin-left: 55px;
  }

  .group_4 {
    margin-left: 55px;
  }

  .space-x-6>*:not(:first-child) {
    margin-left: 6px;
  }

  .text-wrapper_2 {
    padding: 24px 0;
    background-color: #07706a;
    width: 113px;
    height: 67px;
  }

  .text_9 {
    margin-left: 54px;
  }

  .text-wrapper_3 {
    margin-left: 91px;
    padding: 14px 0;
    background-color: #09827b;
    border-radius: 21px;
    width: 108px;
    height: 42px;
    border: solid 1px #e6e6e6;
  }

  .text_10 {
    color: #ffffff;
  }

  .section_3 {
    margin-top: 30px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    width: 1210px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .font_4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 22px;
    color: #666666;
  }

  .text_11 {
    line-height: 16px;
  }

  .image_6 {
    width: 17px;
    height: 16px;
  }

  .text_12 {
    color: #999999;
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 15px;
  }

  .group_5 {
    padding: 20px 0 45px;
    width: 1210px;
    margin: auto;
  }

  .group_6 {
    width: 1210px;
  }

  .space-x-25>*:not(:first-child) {
    margin-left: 25px;
  }

  .section_4 {
    padding: 30px 0 59px 21px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    height: 513px;
  }

  .space-x-29>*:not(:first-child) {
    margin-left: 29px;
  }

  .image_7 {
    width: 423px;
    height: 424px;
  }

  .group_9 {
    margin-top: 10px;
    width: 315px;
  }

  .font_5 {
    font-size: 32px;
    font-family: Microsoft YaHei;
    line-height: 42px;
    font-weight: 700;
    color: #333333;
    width: 256px;
    text-align: left;
  }

  .group_11 {
    margin-top: 26px;
  }

  .space-x-16>*:not(:first-child) {
    margin-left: 16px;
  }

  .group_13 {
    margin: 10px 0 4px;
  }

  .font_7 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 19.5px;
    color: #bebebe;
    width: 90px;
    text-align: left;
  }

  .group_12 {
    line-height: 32px;
    height: 193px;
  }

  .space-x-31 {
    margin-top: 12px;
  }

  .text-wrapper_4 {
    padding: 12px 0;
    background-color: #ffffff;
    width: 35px;
    height: 35px;
    border: solid 1px #e6e6e6;
    -webkit-user-select: none;
    /* Chrome 和 Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+ */
    user-select: none;
    /* 标准语法 */
  }

  .font_10 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 17px;
    color: #333333;
    cursor: pointer;
  }

  .text_23 {
    color: #666666;
    line-height: 9px;
  }

  .text-wrapper_5 {
    padding: 12px 0;
    background-color: #ffffff;
    width: 49px;
    height: 35px;
    border: solid 1px #e6e6e6;
  }

  .font_11 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 30px;
    color: #999999;
  }

  .text_24 {
    color: #09827b;
    line-height: 11px;
  }

  .text-wrapper_6 {
    padding: 16px 0;
    background-color: #09827b;
    width: 35px;
    height: 35px;
    border: solid 1px #e6e6e6;
    cursor: pointer;

    -webkit-user-select: none;
    /* Chrome 和 Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+ */
    user-select: none;
    /* 标准语法 */
  }

  .text_25 {
    line-height: 2px;
  }

  .section_7 {
    margin-left: 15px;
    margin-top: 28px;
    padding: 13px 27px 13px 35px;
    background-color: #0b837c;
    border-radius: 22.5px;
  }

  .space-x-10>*:not(:first-child) {
    margin-left: 10px;
    -webkit-user-select: none;
    /* Chrome 和 Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+ */
    user-select: none;
    /* 标准语法 */
  }

  .image_10 {
    width: 18px;
    height: 20px;
  }

  .text_26 {
    font-size: 17px;
    line-height: 15px;
    cursor: pointer;
  }

  .group_7 {
    margin-top: 11px;
  }

  .group_8 {
    padding: 0 2px 16px;
  }

  .space-x-9>*:not(:first-child) {
    margin-left: 9px;
  }

  .section_5 {
    background-color: #09827b;
    width: 6px;
    height: 27px;
  }

  .text_13 {
    color: #333333;
    font-size: 22px;
    font-family: Microsoft YaHei;
    line-height: 22px;
  }

  .section_6 {
    padding: 16px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .image_8 {
    width: 90px;
    height: 115px;
  }

  .group_10 {
    margin: 30px 8px 0 19px;
    width: 240px;
  }

  .view {
    margin: 31px 8px 0 19px;
  }

  .font_6 {
    width: 260px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 17px;
    font-weight: 700;
    color: #333333;
    text-align: left;
  }

  .text_14 {
    line-height: 18px;
  }

  .text_15 {
    margin-top: 10px;
    font-size: 15px;
  }

  .font_8 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 17px;
    color: #df1510;
  }

  .text_16 {
    margin-top: 19px;
    line-height: 16px;
  }

  .font_9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 13px;
    color: #cccccc;
  }

  .text_17 {
    margin-top: 11px;
    font-size: 15px;
  }

  .text_18 {
    margin-top: -8px;
  }

  .view_2 {
    margin-top: 19px;
  }

  .image_9 {
    border-radius: 20px;
    width: 90px;
    height: 115px;
  }

  .text_19 {
    line-height: 18px;
  }

  .group_14 {
    margin-top: 19px;
  }

  .text_20 {
    line-height: 16px;
  }

  .text_21 {
    font-size: 15px;
  }

  .text_22 {
    margin-top: -9px;
  }

  .view_3 {
    margin-top: 20px;
  }

  .text_27 {
    line-height: 18px;
  }

  .group_15 {
    margin-top: 18px;
    padding-left: 3px;
  }

  .text_28 {
    color: #df1510;
  }

  .text_29 {
    margin-top: -8px;
  }

  .section_8 {
    padding-bottom: 36px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    width: 782px;
    /* min-height: px; */
  }

  .group_16 {
    padding-bottom: 4px;
  }

  .section_9 {
    padding: 29px 27px 22px;
    background-color: #f7f6f6;
    border-radius: 20px 20px 0px 0px;
    width: 782px;
  }

  .space-x-49>*:not(:first-child) {
    margin-left: 49px;
  }

  .text_30 {
    color: #0b837c;
  }

  .section_10 {
    background-color: #0b837c;
    border-radius: 3px;
    height: 6px;
  }

  .pos_2 {
    position: absolute;
    left: 53px;
    right: 702px;
    top: 67px;
  }

  .image_11 {
    margin: 20px 30px 0;
    width: 722px;
    height: 537px;
  }

  .text_31 {
    margin-left: 29px;
    margin-top: 28px;
    line-height: 22.5px;
  }

  .text_32 {
    margin-left: 29px;
    margin-top: 14px;
    line-height: 22.5px;
  }

  .section_11 {
    margin-top: 649px;
    padding: 24px 0;
    filter: drop-shadow(0px 5px 28.5px #efecec1a);
    background-image: url('../../assets/16848940551124030016.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 91px;
    height: 92px;
  }

  .space-y-9>*:not(:first-child) {
    margin-top: 9px;
  }

  .image_12 {
    width: 21px;
    height: 23px;
  }

  .text_33 {
    color: #000000;
  }

  .space-y-12>*:not(:first-child) {
    margin-top: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/view/supply/detail.vue